import { apiSlice } from '../../app/api/apiSlice';
import { VerificationResult } from './types';

const FACE_COMPARE_LOG_FIXED_ID = 'face_compare_log';

interface FaceCompareLogPayload {
  _id: string;
  photo1_url: string;
  photo2_url: string;
}

interface IdentityVerificationLogPayload {
  collection: 'identity_verification_log__c';
  data: {
    candidate__c: string;
    certification_log__c: string;
    status__c: 'passed' | 'failed' | 'blocked';
    attempts__c: Array<{
      attempt_number__c: number;
      status__c: 'passed' | 'failed';
      distance__c: number;
      captured_at__c: string;
    }>;
    failure_reason__c?: string;
    completed_at__c: string;
    browser_info__c: {
      user_agent__c: string;
      platform__c: string;
    };
  };
}

export function buildIdentityVerificationPayload(
  result: VerificationResult,
): IdentityVerificationLogPayload {
  return {
    collection: 'identity_verification_log__c',
    data: {
      candidate__c: result.candidateId,
      certification_log__c: result.certificationLogId,
      status__c: result.status,
      attempts__c: result.attempts.map(a => ({
        attempt_number__c: a.attemptNumber,
        status__c: a.status,
        distance__c: a.distance,
        captured_at__c: a.capturedAt,
      })),
      failure_reason__c: result.failureReason,
      completed_at__c: result.completedAt,
      browser_info__c: {
        user_agent__c: navigator.userAgent,
        platform__c: navigator.platform,
      },
    },
  };
}

const identityVerificationApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    sendIdentityVerificationLog: builder.mutation<
      unknown,
      IdentityVerificationLogPayload
    >({
      query: payload => ({
        url: 'database/identity_verification_log__c',
        method: 'PUT',
        body: payload,
      }),
    }),
    sendFaceCompareLog: builder.mutation<
      unknown,
      { photo1Url: string; photo2Url: string }
    >({
      query: ({ photo1Url, photo2Url }) => {
        const body: FaceCompareLogPayload = {
          _id: FACE_COMPARE_LOG_FIXED_ID,
          photo1_url: photo1Url,
          photo2_url: photo2Url,
        };
        return {
          url: 'database/face_compare_log__c',
          method: 'PUT',
          body,
        };
      },
    }),
  }),
});

export const {
  useSendIdentityVerificationLogMutation,
  useSendFaceCompareLogMutation,
} = identityVerificationApiSlice;
